export const yupLocale = {
    mixed: {
      default: 'Неправильный ввод',
    },
    number: {
      min: 'Должно содержать как минимум ${min} символов',
    },
  };